import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { memo, useMemo } from "react";
import { VersionListContentContainer } from "~/components/AssetModalV2/VersionsPanel/components/VersionListContentContainer";
import { VersionListSectionHeader } from "~/components/AssetModalV2/VersionsPanel/components/VersionListSectionHeader";
import { VersionsListContainer } from "~/components/AssetModalV2/VersionsPanel/components/VersionsListContainer";
import { PublicVersionListItem } from "~/components/AssetModalV2/VersionsPanel/PublicAssetComponents/PublicVersionListItem";
import { usePublicVersionsList } from "~/swr-hooks/versions/usePublicVersionsList";
export const PublicVersionsListContent = /*#__PURE__*/ memo(()=>{
    var _versionsData_data;
    const { data: versionsData } = usePublicVersionsList();
    const versions = useMemo(()=>{
        var _versionsData_data;
        var _versionsData_data_clips;
        return (_versionsData_data_clips = versionsData === null || versionsData === void 0 ? void 0 : (_versionsData_data = versionsData.data) === null || _versionsData_data === void 0 ? void 0 : _versionsData_data.clips) !== null && _versionsData_data_clips !== void 0 ? _versionsData_data_clips : [];
    }, [
        versionsData === null || versionsData === void 0 ? void 0 : (_versionsData_data = versionsData.data) === null || _versionsData_data === void 0 ? void 0 : _versionsData_data.clips
    ]);
    const currentVersion = useMemo(()=>versions.find((v)=>v.isDefault), [
        versions
    ]);
    const olderVersions = useMemo(()=>versions.filter((v)=>!v.isDefault), [
        versions
    ]);
    return /*#__PURE__*/ _jsx(VersionsListContainer, {
        children: /*#__PURE__*/ _jsx(VersionListContentContainer, {
            children: !!versions.length && /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    /*#__PURE__*/ _jsx(VersionListSectionHeader, {
                        title: "Current Version"
                    }),
                    !!currentVersion && /*#__PURE__*/ _jsx(PublicVersionListItem, {
                        version: currentVersion
                    }, currentVersion.id),
                    /*#__PURE__*/ _jsx("div", {
                        className: "my-4 h-px w-full bg-grey-4"
                    }),
                    !!olderVersions.length && /*#__PURE__*/ _jsxs(_Fragment, {
                        children: [
                            /*#__PURE__*/ _jsx(VersionListSectionHeader, {
                                title: "Older Versions"
                            }),
                            olderVersions.map((version)=>/*#__PURE__*/ _jsx(PublicVersionListItem, {
                                    version: version
                                }, version.id))
                        ]
                    })
                ]
            })
        })
    });
});
PublicVersionsListContent.displayName = "PublicVersionsListContent";
